<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 2.5s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes ss-1 {
    0%,
    20% {
      opacity: 1;
    }
    20%,
    100% {
      opacity: 0;
    }
  }
  #ss-1 {
    animation-name: ss-1;
  }
  @keyframes ss-2 {
    0%,
    20% {
      opacity: 0;
    }
    20%,
    40% {
      opacity: 1;
    }
    40%,
    100% {
      opacity: 0;
    }
  }
  #ss-2 {
    animation-name: ss-2;
  }
  @keyframes ss-3 {
    0%,
    40% {
      opacity: 0;
    }
    40%,
    60% {
      opacity: 1;
    }
    60%,
    100% {
      opacity: 0;
    }
  }
  #ss-3 {
    animation-name: ss-3;
  }
  @keyframes ss-4 {
    0%,
    60% {
      opacity: 0;
    }
    60%,
    80% {
      opacity: 1;
    }
    80%,
    100% {
      opacity: 0;
    }
  }
  #ss-4 {
    animation-name: ss-4;
  }
  @keyframes ss-5 {
    0%,
    80% {
      opacity: 0;
    }
    80%,
    100% {
      opacity: 1;
    }
  }
  #ss-5 {
    animation-name: ss-5;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 301.8 582.8" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="ss-5">
      <path
        fill="var(--flesh)"
        d="m288 40-20 23c-5 5-7 12-10 18-14 29-30 57-45 85l-2 4-15-17c0-2 2-6-2-7 20-26 36-54 54-82l7-12c2-3 1-6-1-9-4-6-1-14-5-21-1-1 2-1 3-1 4 2 5 5 6 9 0 2 0 4 2 4 3 0 2-3 2-4 0-4 2-7 3-10 0-2 1-3 3-2s2 2 1 3v10c3-2 4-6 6-9 1-1 2-4 4-3s1 3 1 5c-1 1-2 3-1 4h2c1-1 2-3 4-1v4c-1 3-6 4-4 7 2 2 4-3 7-2Z"
      />
      <path
        fill="var(--hair)"
        d="M234 532c5 2 5 5 7 10 1 7 6 13 8 21 4 13 3 15-9 20h-4c0-2-1-2-2-2-8-3-11-6-11-14 0-5 0-10-4-14a6 6 0 0 1-2-8c2-3 2-6 1-9 2 0 4 2 5 0 3-4 7-4 11-4Z"
      />
      <path
        fill="var(--pants)"
        d="M100 332c26 6 53 7 79 0a32 32 0 0 1 6 0c1 26 4 52 13 77 1 4 0 6-2 8-10 8-21 9-33 12l-13 2c-3 0-5-1-6-4-1-8-4-15-6-22a61 61 0 0 0-2-6c-3 2-4 5-5 7l-5 18c-1 6-4 9-10 11-7 1-14 3-21 2-10-4-17-12-26-17-2-4 0-7 1-11l11-75a23 23 0 0 1 1-3c1-2 3-2 4-1l14 2Z"
      />
      <path
        fill="var(--flesh)"
        d="M83 151a2 2 0 0 0-2 3c2 10-3 18-8 25 0-5-4-9-6-13l-16-28c-6-10-8-21-11-32L27 57C23 45 15 34 7 23a47 47 0 0 0-5-5c-1-1-3-3-2-4A19 19 0 0 0 5 3c0-2 3 1 4 2 1 4 3 8 6 11 2-3 0-4-1-6l-2-5c0-2-3-4 0-5 2-1 3 1 4 3l5 10a29 29 0 0 0 2 3 2 2 0 0 0 3 1v-2l-1-8c0-2 0-4 2-4s3 1 3 3l2 8a19 19 0 0 0 3 8c3 4 5 5 7 0 2-3 4-6 8-6 2 0 3 0 4 2l-2 3c-5 6-7 14-11 21-4 6 2 13 4 19 6 14 13 26 21 39 4 8 6 18 12 26l9 16c-1 3-4 5-4 9ZM8 14l-1-1-1 1a8 8 0 0 0 1 1ZM163 429c12-3 23-4 33-12 2 15 8 28 16 41 6 11 9 23 12 35a344 344 0 0 0 9 35 36 36 0 0 1 1 4c-4 0-8 0-11 4-1 2-3 0-5 0 0-15-9-27-16-39-5-8-10-16-11-25a31 31 0 0 0-9-18l-19-25ZM69 420c9 5 16 13 26 17-3 7-8 12-12 17-3 4-5 7-6 12-2 17-11 30-20 45-2 5-5 10-4 16l-1 1c-2 4-4 5-6 0-2-3-6-4-9-5 6-12 6-25 9-38 2-12 6-23 12-34 6-9 11-20 11-31ZM156 176c-2 2-3 4-7 2s-7 2-11 1c-4 0-9 2-12-3 1-7-4-13-7-19-2-4-5-7 0-11l1 2a1 1 0 0 0 1-1c-2-7 1-13 2-20 1-5 3-6 7-6a45 45 0 0 0 18 0c4-2 8 0 7 6a6 6 0 0 0 2 4l3 9v6h1v-2c5 0 4 3 4 5 0 7-6 11-8 17-2 3-2 6-1 10Z"
      />
      <path
        fill="var(--hair)"
        d="M37 523c3 1 7 2 9 5 2 5 4 4 6 0l1-1 1 6c4 9 4 9-4 16a6 6 0 0 0-3 6c0 4 1 8-2 12-4 6-14 9-21 5-5-3-7-11-3-18 5-8 10-15 11-24l5-7ZM161 144v2h-1v-6l-3-9a6 6 0 0 1-2-4c1-6-3-8-7-7a45 45 0 0 1-18 1c-4 0-6 1-7 6-1 7-4 13-2 20a1 1 0 0 1-1 1l-1-2c-2-9-1-19 0-29 0-4 1-7 6-7 6-1 13-4 19-2 5 0 10 1 12 6a2 2 0 0 0 1 1c3 2 8 3 7 8-1 4 1 8-2 12l-1 9Z"
      />
      <path
        fill="var(--shirt)"
        d="m100 332-14-2c-1-1-3-1-4 1-11-6-5-16-6-25-1 6 3 11 3 17 0 2 3 4 5 4 5 1 9 3 14 3 1-1 2 0 2 2ZM138 179c-4 0-9 2-12-3l-2-1"
      />
      <path
        fill="var(--shirt)"
        d="m211 170-15-17c-2 0-3-3-5-2a13 13 0 0 1-2 3c-8 11-20 17-33 22-2 2-3 4-7 2s-7 2-11 1l-14-4h-1c1-3 0-5-3-4a8 8 0 0 1-7-3c-8-8-18-14-23-25l-3-1c-1 3-4 5-4 9a2 2 0 0 0-2 3c2 10-3 18-8 25-1 7 3 12 7 17 2 4 6 7 6 12 0 17 0 33-3 50-3 16-8 32-6 48-2 6 2 11 2 17 0 2 3 4 5 4 5 1 9 3 14 3 1-1 2 0 2 2 26 6 53 7 79 0a32 32 0 0 1 6 0c5 0 4-3 4-7-3-25-5-50 0-76a64 64 0 0 0 1-21 28 28 0 0 1 3-18l18-34v-6Z"
      />
      <path
        fill="var(--shirt)"
        d="M196 153c0-2 2-6-2-7-2 1-2 3-3 5 2-1 3 2 5 2Z"
      />
    </g>
    <g id="ss-2">
      <path
        fill="var(--flesh)"
        d="M110 452c-3 9-6 17-4 26l-1 11c-3 18-3 36-7 53a20 20 0 0 0 0 3c0 10 0 11 9 14 3 1 6 2 5 6 0 4-1 4-4 3-5-3-10-5-11 4l-3 1c-3 1-2-3-4-4-2 2-2 5-5 5s-1-3-3-4c-4 4-4 4-7 0 0-2-1-1-2-1l-5 1v-3l14-9c5-3 3-9 3-14 1-17-1-34-2-51 0-5-1-10 1-15a28 28 0 0 0 0-10l-3-26c11-1 21 2 29 10Z"
      />
      <path
        fill="var(--shirt)"
        d="M110 452c-8-8-18-11-29-10-4-13 0-25 4-37a64 64 0 0 1 12-21c3-3 5-5 9-5 3 2 3 6 5 9v4l16 30c4 6 9 7 15 6a9 9 0 0 0 8-8c1-8 6-16 7-24 0-5 3-10 3-16 0-8 0-9 9-7 16 2 22 14 26 27l6 21 1 2 1 7c1 7 0 11-6 14-7 3-13 7-20 5-3-1-4 1-5 2-8 4-15 9-23 12a13 13 0 0 1-10 1l-21-6c-4-1-5-4-8-6Z"
      />
      <path
        fill="var(--flesh)"
        d="M172 451c1-1 2-3 5-2 7 2 13-2 20-5 6-3 7-7 6-14l-1-7 7 2 15 7c7 3 9 8 10 15 1 25-5 48-14 70l-9 22c-3 1-7 0-8 5l-3 2c-3 0-3-2-3-3 1-11 4-23 2-34v-17l8-24v-4c-2-2-3 0-5 1-5 1-7 4-6 10 2 17 1 35-1 52 0 6-1 11 1 17-3 9-1 17 6 24a34 34 0 0 1 3 4c-3 2-4 2-6-1-1-1-3-2-4 1 0 1 1 4-2 4-4 1-2-3-3-5h-1c-3 0-2 5-6 5-2-1 0-4-2-5l-4 3c-2 1-5 1-4-3 2-6-2-5-5-4-2 0-5 3-7 0-1-3 2-5 4-7a19 19 0 0 1 7-2c8-1 9-2 9-10 0-13 0-25-2-38l-4-41a47 47 0 0 0-1-5 39 39 0 0 0-2-13ZM169 373c-9-2-9-1-9 7 0 6-3 11-3 16-1 8-6 16-7 24a9 9 0 0 1-8 8c-6 1-11 0-15-6l-16-30v-10c0-6 0-7 6-5 8 3 14 2 20-3l7-7c2-1 3-2 4 1 0 4 3 7 6 10 0 4-1 9 1 14l1-14v-9c4 4 9 1 13 4Z"
      />
      <path
        fill="var(--hair)"
        d="M154 379c-3-4-6-6-7-11 0-3-1-2-3-1l-7 7c-6 5-12 6-20 3-6-2-6-1-6 5v6c-2-3-2-7-5-9-2-11-1-21 0-31 0-3 1-4 3-5 7-3 14-5 22-5 12 0 26 8 25 24a54 54 0 0 0 0 7v9Z"
      />
      <path
        fill="var(--pants)"
        d="M172 451a39 39 0 0 1 2 13l-6-1c-8-1-8-1-10 7l-2 15c0 5-3 7-8 6h-5c-7-6-17-6-24-12 1-7-1-14-1-21l21 6a13 13 0 0 0 10-1c8-3 15-8 23-12Z"
      />
      <path
        fill="var(--hair)"
        d="M197 543c0 1 0 3 2 3l4-2c0-5 5-4 8-5 2 9 6 18 14 24 3 2 5 4 4 8s-4 5-7 5a17 17 0 0 1-17-4 34 34 0 0 0-3-5c-7-6-9-14-6-23Z"
      />
      <path
        fill="var(--flesh)"
        d="M119 479c7 6 17 6 24 12-4 4-7 9-14 9-5-2-10-4-13-10 0-4-2-8 3-11Z"
      />
      <path
        fill="var(--hair)"
        d="M116 490c3 6 8 8 13 10l5 10c2 3 1 4-3 5-12 0-15-1-15-13a65 65 0 0 1 0-12Z"
      />
      <path fill="var(--flesh)" d="m202 423-1-2Z" />
      <path fill="var(--pants)" d="m154 379 2-1-1 14c-2-5-1-9-1-13Z" />
    </g>
    <g id="ss-1">
      <path
        fill="var(--hair)"
        d="M164 488c3 6 10-2 16 1l5 20c2 3 1 5-3 6-15 0-18-2-19-14a65 65 0 0 1 1-13Z"
      />
      <path
        fill="var(--pants)"
        d="M173 446c2 4 5 15 5 20-2 0 5 24 2 23-9-1-17 2-23 0-1 6-11-12-11-7-1 6 2 8-4 7a20 20 0 0 0-3 0c-8-6-20-7-28-13 1-7-1-15-2-22 9 2 17 3 25 6a16 16 0 0 0 12-1l27-13Z"
      />
      <path
        fill="var(--flesh)"
        d="M185 476c-8 6-20 6-28 13 5 4 8 10 16 10 6-3 12-5 16-11-1-4 2-9-4-12ZM106 452c-3 9-5 17-4 26 1 4 0 8-1 11-2 18-3 36-6 53a21 21 0 0 0 0 3c-1 10-1 11 9 14 3 1 5 2 5 6-1 4-2 4-5 3-5-3-9-5-11 4l-2 1c-4 1-3-3-4-4-2 2-2 5-5 5s-2-3-4-4c-4 4-4 4-6 0-1-2-2-1-3-1l-5 1v-3l14-9c5-3 3-9 3-14 1-17 0-34-1-51v-15a28 28 0 0 0 1-10l-4-26c11-1 21 2 29 10Z"
      />
      <path
        fill="var(--shirt)"
        d="M106 452c-8-8-18-11-29-10-3-13 0-25 5-37a64 64 0 0 1 12-21c2-3 5-5 9-5 2 2 2 6 4 9v4l17 30c3 6 9 7 15 6a9 9 0 0 0 7-8c1-8 6-16 7-24 1-5 3-10 3-16 0-8 1-9 9-7 16 2 22 14 26 27l6 21 1 2 1 7c2 7 0 11-6 14s-12 7-20 5c-2-1-3 1-5 2l-22 12a13 13 0 0 1-11 1c-7-3-14-3-21-5l-8-7Z"
      />
      <path
        fill="var(--flesh)"
        d="m191 548 1-21c1-17 2-34 0-51a10 10 0 0 1 0-4c1-8 2-16 1-23a19 19 0 0 1 0-5c-6 3-12 7-20 5-2-1-3 1-5 2a39 39 0 0 1 2 13 45 45 0 0 1 1 5l5 41c2 13 1 25 1 38 0 8-1 9-9 10a19 19 0 0 0-6 2c-3 2-6 4-4 7 1 3 4 0 6 0 4-1 7-2 5 4-1 4 2 4 5 3l4-3c1 1-1 4 2 5 3 0 2-5 5-5h1c1 2 0 6 3 6 3-1 2-3 2-5 1-3 3-2 4-1 2 3 4 3 6 1a34 34 0 0 0-3-4c-7-7-7-20-7-20ZM165 373c-8-2-9-1-9 7 0 6-2 11-3 16-1 8-6 16-7 24a9 9 0 0 1-8 8c-5 1-11 0-14-6l-17-30v-4l1-6c-1-6 0-7 6-5 7 3 13 2 19-3l7-7c2-1 4-2 4 1 0 4 4 7 6 10 1 4-1 9 1 14 2-5 1-9 1-14l1-9c3 4 9 1 12 4Z"
      />
      <path
        fill="var(--hair)"
        d="M150 379c-2-4-6-6-6-11 0-3-2-2-3-1l-8 7c-6 5-12 6-19 3-6-2-7-1-6 5l-1 6c-2-3-2-7-4-9-2-11-1-21-1-31 0-3 2-4 4-5 7-3 14-5 21-5 12 0 26 8 25 24a54 54 0 0 0 1 7l-1 9Z"
      />
      <path
        fill="var(--flesh)"
        d="M111 476c8 6 20 6 28 13-5 4-9 10-16 10-6-3-13-5-16-11 0-4-2-9 4-12Z"
      />
      <path
        fill="var(--hair)"
        d="M107 488c3 6 10 8 16 11l6 10c1 3 0 5-4 6-14 0-17-2-18-14a65 65 0 0 1 0-13Z"
      />
      <path fill="var(--flesh)" d="m198 423-1-2Z" />
      <path
        fill="var(--pants)"
        d="m150 379 2-1c0 5 1 9-1 14-2-5 0-9-1-13Z"
      />
    </g>
    <g id="ss-3">
      <path
        fill="var(--shirt)"
        d="M162 381c22 12 37 29 40 54 0 3 0 5 2 8 3 6 0 9-7 11l-10 2c-3 1-5 2-8 0h-5c-4 1-6 4-10 6-4 4-10 8-16 6-14-3-29 1-42-7-4-3-8-4-13-1s-10 1-16 0c-2 0-2-1-2-3-3-6-2-12-2-19 2-3 2-6 2-10 4-21 14-37 35-46 4 4 5 8 7 13l10 26c1 4 3 7 8 7s10-1 12-6l8-21c3-7 1-15 7-20Z"
      />
      <path
        fill="var(--flesh)"
        d="M174 456h5c3 2 5 2 8 0s7-1 10-2c7-2 9-6 6-11l-1-8 23 7c6 1 8 5 9 10 2 17-1 34-8 50-5 13-11 26-12 41-2 0-5 1-5 4-1 3-4 4-6 4-3 1-3-3-4-4a1 1 0 0 0-1-2c-3 7-2 13 3 19 0 3 3 4 4 6 0 1 2 2 0 3h-3c-3-2-5-4-5 2l-2 2c-2 0-2-2-3-3l-1-3-2 3c-2 3-4 5-6 0-1-2-2-1-3 0-3 1-6 1-5-4s-2-4-4-3c-3 1-6 3-8 0-1-3 2-6 5-7a29 29 0 0 1 5-2c8-1 10-3 10-11 1-18-2-36-4-53l-1-9-4-29Zm23 87 2-2c1-10 4-20 1-30l-3 32Zm4-49 5-18v-4h-5c-2 0-1 2-1 3-1 7 2 13 1 19ZM73 438c0 7-1 13 2 19 0 1 0 3 2 3 6 1 11 4 16 0s9-2 13 1l7 13c3 5 0 5-4 5-7 0-8 0-9 8a214 214 0 0 0 2 55c0 5 2 9 6 12s4 7 4 10-2 4-4 3c-2-2-4-2-4 1-1 2-2 4-4 3-3 0-2-3-3-4-3-1-4 11-9 1-2 0-4 6-7 2-2-3-5-1-7-2s-1-3 0-3l6-4c1 0 2-1 1-3 4 0 4-4 5-7 2-1 2-3 2-5a175 175 0 0 0-3-27l-4-22-3 19c-1 8 2 15 2 23a9 9 0 0 1 0 2c-1 2 1 6-3 6-3 0-8 0-9-5-1-3-3-2-5-3 1-12-6-21-10-31-6-15-10-31-9-48 1-8 4-14 13-17l16-5Zm6 52v-12c0-2 0-4-2-4h-3v5l5 11ZM162 381c-6 5-4 13-7 20l-8 21c-2 5-7 6-12 6s-7-3-8-7l-10-26c-2-5-3-9-7-13 1-2 0-4-1-6s-1-3 2-3l3 12c1-5 3-9 2-14 0-2 0-4 3-3 11 6 21 2 31-5 4-2 4-1 5 3l3 17 3-17c3 5 2 10 1 15Z"
      />
      <path
        fill="var(--hair)"
        d="m161 366-3 17-3-17c-1-4-1-5-5-3-10 7-20 11-31 5-3-1-3 1-3 3 1 5-1 9-2 14l-3-12-2-20a27 27 0 0 1 1-10c1-3 2-5 6-6l20-5c7 0 13 3 19 8 9 8 6 17 6 26Z"
      />
      <path
        fill="var(--pants)"
        d="M109 479c4 0 6-1 4-5l-7-13c13 8 28 5 42 8 6 1 12-3 16-7 3-2 6-5 10-6l4 29-7 4c-5 3-9 4-14-1l-16-14c-3-2-6-2-10-1a89 89 0 0 0-15 9c-4 2-6 2-7-3Z"
      />
      <path
        fill="var(--hair)"
        d="M201 564c-5-6-6-12-3-19a1 1 0 0 1 1 2c1 1 1 5 4 4 2 0 5-1 6-4 0-3 3-4 5-4 1 0 2-1 2 1 1 8 7 11 14 14l11 6c3 3 3 6 0 9-5 4-13 5-21 1-6-3-12-9-19-10ZM63 539c2 1 4 0 5 3 1 5 6 5 9 5 4 0 2-4 3-6a9 9 0 0 0 0-2c3 3 5 7 6 12-1 3-1 7-5 7-5 1-9 3-13 6-7 4-15 8-24 7-2 0-5 0-6-2-1-3 0-5 2-7a24 24 0 0 1 5-4c8-5 15-10 18-19Z"
      />
      <path fill="var(--flesh)" d="M73 438Z" />
    </g>
    <g id="ss-4">
      <path
        fill="var(--hair)"
        d="M213 534c1 0 3-1 4 1 1 8 8 12 15 15l7 3c2 1 5 3 4 6a7 7 0 0 1-4 6l-8 3h-3c-9-4-17-10-27-14-9-4-10-12-2-19 2 2 0 7 4 7 3-1 7-2 7-6 0-2 2-2 3-2Z"
      />
      <path
        fill="var(--shirt)"
        d="M90 427c5-10 1-21 2-31l1-31c2-13-2-24-12-33-2-2-4-4-5-8 6 1 9-2 13-6 5-5 4-12 4-18l7 4c7 7 16 11 24 16l6 15c4 5 11 8 17 5 8-4 10-12 13-20 9-4 19-5 26-13l10-7c3 1 3 2 3 4v10c0 7 2 10 9 13 2 0 2 2 2 3-1 3-2 6-5 7-12 5-17 15-20 27-3 15-7 29-6 45 1 5-3 8-3 13-11 4-22 6-31 13-15 12-16 11-30-1a28 28 0 0 0-25-7Z"
      />
      <path
        fill="var(--flesh)"
        d="M93 300c0 6 1 13-4 18-4 4-7 7-13 6-9-11-15-25-24-37-7-11-10-25-13-38l-7-34c-2-13-11-24-19-34-4-7-4-13-2-19 1-3 10-3 12-1 4 4 5 10 8 15v-11c-1-2-2-4 1-4s2 1 3 3c3 4 2 8 4 12 0 2 0 4 2 4v-7c0-2 0-3 2-3 1-1 2 1 2 2a22 22 0 0 0 5 9v7c-5 12-3 24 2 37l17 47a18 18 0 0 0 4 7l20 21ZM210 330c-1-1 0-3-2-3-7-3-9-6-9-13v-10c0-2 0-3-3-4l8-7a49 49 0 0 0 16-18c5-9 13-14 20-21l24-29c3-4 5-9 1-15-3-6 1-13-2-19l2-2a3 3 0 0 1 4 2 80 80 0 0 1 2 8c1 2 1 3 3 3 2 1 3-1 3-2l4-8c2-2 3-5 6-4s0 4-1 5l-1 6c4-1 4-5 6-7 1-1 2-3 4-1v4c-1 3-4 5-5 9 4-1 5-4 7-5 1-1 3-2 4-1a2 2 0 0 1 0 3v6a4 4 0 0 1-1 5c-4 4-7 10-12 14a25 25 0 0 0-9 9l-26 38c-12 18-28 32-41 50l-2 7ZM213 534c-1 0-3 0-3 2 0 4-4 5-7 6-4 0-2-5-4-7 2-11 1-23-1-34a52 52 0 0 1 3-25c1-4 0-5-4-7-7-2-13 1-19 2-3-2-7-1-11-2s-5-2-4-6c3-15 12-25 23-35 7 1 13 4 18 6l18 9c5 2 7 7 8 13a113 113 0 0 1-10 51c-4 9-9 17-7 27ZM67 535c0-8-2-16-6-23a93 93 0 0 1-8-49c1-5 3-9 7-13 7-7 16-12 24-17 5 1 11 0 15 4 6 6 11 13 13 22 2 12 3 12-11 14-3 0-7-2-10 1-8 0-10 3-8 10s3 15 0 23c-3 9-1 18-2 27l-1 4c0 4-2 5-6 4s-6-3-7-7Z"
      />
      <path
        fill="var(--pants)"
        d="M91 474c3-3 7-1 10-1 14-2 13-2 11-14-2-9-7-16-13-22-4-4-10-3-15-4l6-6a28 28 0 0 1 25 7c14 12 15 13 29 1 10-7 21-10 32-13 3 3 7 3 10 6-11 10-20 20-23 35-1 4 1 5 4 6s8 0 11 2c-4 10-9 12-18 7a66 66 0 0 1-14-11 21 21 0 0 0-12-7c-5 0-7 1-9 5-2 8-7 14-12 20-3 3-6 3-9 1-5-3-9-7-13-12Z"
      />
      <path
        fill="var(--flesh)"
        d="M160 320c-3 8-5 16-13 20-6 3-14 0-17-5l-6-15c1-3-1-5-3-8-2-4-5-8-1-13 2 1 0 3 3 4-3-9 1-16 3-23 0-3 2-5 5-4a42 42 0 0 0 19-1c2-1 6 0 7 3 0 7 6 12 4 20a4 4 0 0 0 1 4l1-4c4 1 4 2 3 6 0 6-5 10-6 16Z"
      />
      <path
        fill="var(--hair)"
        d="M67 535c1 4 3 6 7 7s6 0 6-4l1-4a93 93 0 0 1 5 13c2 3 0 6-3 6-7 1-13 5-19 9a43 43 0 0 1-19 5c-2 0-5 0-6-3s0-5 2-7a38 38 0 0 1 5-4c6-4 13-8 16-16 1-3 3-2 5-2ZM163 298l-1 4a4 4 0 0 1-1-4c2-8-4-13-4-20-1-3-5-4-7-3a42 42 0 0 1-19 1c-3-1-5 0-5 3-2 8-6 15-3 24-3-1-1-3-3-4-1-9 0-19 1-28 0-3 0-5 3-6 8-2 16-5 24-3 4 1 8 2 9 6l1 1c12 4 7 13 6 21l-1 8Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>